import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * BrandLogo — marca ONOR CODE con los renders oficiales (identidad v2.1).
 *  - normal   → wordmark [ONOR] CODE (render 3D recortado).
 *  - compact  → isotipo [O] CODE.
 * Botón de inicio inteligente: con sesión manda al dashboard según rol; sin
 * sesión, a la landing. `to` fuerza el destino.
 */
const BrandLogo = ({ compact = false, showCode = true, to, className = '' }) => {
  const { user, isCoach, isAdmin } = useAuth();
  let target = '/';
  if (user) {
    if (isAdmin?.()) target = '/admin/dashboard';
    else if (isCoach?.()) target = '/coach/dashboard';
    else target = '/app/dashboard';
  }
  const href = to || target;
  return (
    <Link
      to={href}
      className={`group inline-flex items-center ${className}`}
      aria-label="ONOR CODE — inicio"
      data-testid="brand-logo"
    >
      {compact || !showCode ? (
        <img
          src="/brand/app-icon-square.webp"
          alt="ONOR CODE"
          width="40"
          height="40"
          draggable="false"
          className="h-10 w-10 rounded-lg transition-transform duration-normal ease-spring group-hover:scale-105"
        />
      ) : (
        <img
          src="/brand/wordmark-3d-tight.webp"
          alt="ONOR CODE"
          width="91"
          height="48"
          draggable="false"
          className="h-12 w-auto transition-transform duration-normal ease-spring group-hover:scale-[1.03]"
        />
      )}
    </Link>
  );
};

export default BrandLogo;
